/* eslint-disable jsdoc/require-returns-description */
import ErrorBoundaryNew from './errorBoundary/ErrorBoundary.jsx'
import ErrorBoundaryDevTrigger from './errorBoundary/ErrorBoundaryDevTrigger.jsx'

/**
 * Chooses between legacy and new Error Boundary implementations via Statsig gate.
 *
 * @param {{ children: React.ReactNode }} props
 * @returns {React.ReactElement}
 */
function ErrorBoundaryContainer({ children }) {
  return (
    <ErrorBoundaryNew>
      <ErrorBoundaryDevTrigger />
      {children}
    </ErrorBoundaryNew>
  )
}

export default ErrorBoundaryContainer
